import { Component, OnInit, Inject, Input } from '@angular/core';
import { Utility } from '../../../../common/utility';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { DialogService } from '../../../../shared/services/dialog.service';
import { AppMessages } from '../../../../shared/constants/messages';
import { AppConstants } from '../../../../shared/constants/constants';
import { Page } from '../../../../models/list/page.model';
import { ClinicAccessService } from './clinic-access.service';

@Component({
    selector: 'clinic-access',
    templateUrl: 'clinic-access.component.html',
    providers: [ClinicAccessService]
})

export class ClinicAccessComponent implements OnInit {
    public dataRow = [];
    public clinicSelected = [];
    public isValidCountry = false;
    public isValidateClinicAccess = false;
    public page = new Page();
    public filterData = { countryId: null };
    public countrySelected: any = null;
    public klass = 'patientinformation';
    public pageSize = 5;
    countries: any[];

    public dataMessage = {
        emptyMessage: AppMessages.list.noRecord,
        totalMessage: AppMessages.list.total
    };

    public customClasses = AppConstants.table.footerClasses;

    constructor(public utility: Utility,
        private clinicAccessService: ClinicAccessService,
        public dialogService: DialogService,
        public dialogRef: MdDialogRef<ClinicAccessComponent>,
        @Inject(MD_DIALOG_DATA) public data: any) { }

    ngOnInit() {
        this.getCountriesByBaseClinic();
    }

    getCountriesByBaseClinic() {
        this.clinicAccessService.getCountriesByBaseClinic(false).subscribe(
            (result) => {
                if (result) {
                    this.countries = result.json();
                }
            }
        );
    }

    onCloseDialog() {
        this.dialogRef.close();
    }

    getClinicByCountry() {
        this.page.size = this.pageSize;
        this.clinicAccessService.getCentresByBaseClinic(this.countrySelected.id, this.data.patientId, false).subscribe(
            (result) => {
                const data = result.json();
                this.page.totalElements = data.length;
                this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
                this.page.pageNumber = 0;
                this.dataRow = data;
                this.clinicSelected = this.dataRow.filter(item => item.isSelected === true);
            }
        );
    }

    setClinicPage(pageInfo) {
        this.page.pageNumber = pageInfo.offset;
    }

    selectCountry() {
        if (this.countrySelected) {
            this.isValidCountry = false;
            this.getClinicByCountry();
        } else {
            this.dataRow = [];
        }
    }

    clinicSelectedChange(row, e) {
        if (e.checked) {
            this.isValidateClinicAccess = false;
            this.clinicSelected.push(row);
        } else {
            const indexOf = this.clinicSelected.indexOf(row);
            this.clinicSelected.splice(indexOf, 1);

        }
    }

    onClickSave() {
        if (this.countrySelected) {
          if (!this.clinicSelected.length) {
            this.isValidateClinicAccess = true;
          } else {
            this.isValidateClinicAccess = false;
            const clinicIdArr = this.clinicSelected.map(item => item.id);
            this.dialogService.openConfirmationDialog({ message: AppMessages.waitingRoom.confirmAddPatient }).subscribe(
              result => {
                if (result) {
                  this.clinicAccessService.addPatientUserCentre(this.countrySelected.id, this.data.patientId, clinicIdArr).subscribe(
                    (result1) => {
                      if (result1) {
                        this.dialogRef.close();
                      }
                    }
                  );
                }
              }
            );
          }
        } else {
          this.isValidCountry = true;
        }
      }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-patient-user/clinic-access/clinic-access.component.ts